// modules
import FetchService from 'modules/Fetch';
import ErrorService from 'modules/Error';
import LocaleService from 'modules/Localization';
import RoutingStore from 'modules/Routing';
import { CookieStorage, LStorage } from 'modules/Storage';
import LoggerService from 'modules/Logger';
import { CleverTapService } from 'modules/CleverTap';
import AnalyticsService from 'modules/Analytics/service';
import { EVENTS } from 'modules/Analytics/consts';
// config
import { LOCAL } from 'config';
// store
import { broker } from 'modules/TradingChart/consts';
import { NotificationType } from '../TradingChart/components/TradingView/sources/charting_library';
import AuthStore from './store';
// constants
import { PLATFORM_ID, CLIENT_ID } from './consts';

class AuthService extends AuthStore {
  // properties
  redirectURL = RoutingStore.getExternalLinkByKey('TRADING_APP');
  // auth resolving promise flag
  refreshPromise: Promise<HttpResponse<RefreshTokensResponse>> | undefined;
  // logout proccess is running
  isLogouting = false;

  redirectQuery: LoginRedirectQuery = {
    client_id: CLIENT_ID,
    redirect_uri: this.redirectURL,
    platform_id: PLATFORM_ID,
    dev_redirect_uri: LOCAL ? window.location.origin : undefined,
  };

  public init = async () => {
    await this.verifyToken();
    CookieStorage.subscribeCookieChange(
      'user_id',
      this.handleAuthCookieChange,
    );

    CookieStorage.subscribeCookieChange(
      'access_token',
      this.handleAuthCookieChange,
    );
  };

  public verifyToken = async () => {
    const response = await FetchService.request<
      'GATEAWAY_WORKER',
      GetTokensResponse
    >('GATEAWAY_WORKER', '/verify-access-token', 'VERIFY_TOKEN');

    if (response.success) {
      LoggerService.log('APP', 'Token verified');
    }
  };

  private handleAuthCookieChange: CookieChangeHandler = (type, key) => {
    // check cookies keys
    const logoutKeys = key === 'access_token' || key === 'user_id';

    // if delete action
    if (type === 'delete' && logoutKeys) {
      this.logout();
    }
  };

  public refreshTokenRequest = async (unauthorizedRequest = false) => {
    this.refreshPromise = FetchService.request<'LOGIN', RefreshTokensResponse>(
      'LOGIN',
      '/auth/refresh-access-token',
      'REFRESH_TOKEN',
      {
        method: 'POST',
        query: {
          client_id: CLIENT_ID,
          response_type: 'token',
          redirect_uri: this.redirectURL,
        },
      },
    );

    const response = await this.refreshPromise;

    this.refreshPromise = undefined;

    if (response.success) {
      LoggerService.log('APP', 'access-token-refreshed');
    } else if (unauthorizedRequest) {
      ErrorService.handleError('UNAUTHORIZED_REQUEST', response?.error?.message);
      if (broker.instance) {
        broker.instance.showNotification(
          LocaleService.translate('UNAUTHORIZED_REQUEST'),
          LocaleService.translate('LOGIN_SESSION_EXPIRED_MESSAGE'),
          NotificationType.Error,
        );
      }
      this.logout();
    } else {
      this.logout();
    }
  };

  public logoutRedirect = (isLogoutRedirect = false) => {
    const routeKey: ExternalRoutesKeys = isLogoutRedirect
      ? 'LOGIN_SERVICE_LOGOUT'
      : 'LOGIN_SERVICE';

    RoutingStore.goToExternalRoute<LoginRedirectQuery>(routeKey, {
      query: {
        ...this.redirectQuery,
        redirect_path: window.location.pathname,
      },
      target: '_self',
    });
  };

  public logout = (isLogoutRedirect = false) => {
    this.isLogouting = true;

    AnalyticsService.sendEvent(EVENTS.LOGGED_OUT, {}, true);

    CleverTapService.logout();

    AnalyticsService.logout();

    LStorage.removeItem('LOGIN_COUNT');

    this.logoutRedirect(isLogoutRedirect);
  }
}

export default new AuthService();
